<template>
  <div class="VotingForm">
    <div class="dtlvoto">{{this.InfoRange.Det_VotingReference}}</div>
    <div class="votoDocen" v-if="votoDocen">
      <div class="titutleDoc"><h3>Candidatos Docentes</h3></div>
      <div class="container">
        <div class="row">
          <div v-for="item of this.InfoRange.VotingTeachers" :key="item.id" class="col-12 col-md-6 col-sm-12 col-lg-4">
            <div v-if="item.Id_Person === 0" class="searchVoto row card text-center" :id="item.Id_VotingUsers">
              <div class="card-header col-md-12">Voto en Blanco</div>
              <div class="card-body searchVotoSelect"><img width="200" height="200" src="@/assets/images/votoBlanco.png" id="item.Id_VotingUsers" class="img-fluid" /></div>
              <div class="card-footer">
                <div class="row text-center">
                  <div class="col-md-6"><img src="@/assets/images/VotoPropuesta.png" class="img-fluid imgProp imgPropVB" /></div>
                  <div class="col-md-6">
                    <div class="form col-md-12">
                      <input type="checkbox" class="checkVal" :id="'check_'+item.Id_VotingUsers" v-on:click="executeVotoDocent" />
                      <label :for="'check_'+item.Id_VotingUsers" style="--d: 90%;"><svg viewBox="0,0,50,50"><path d="M5 30 L 20 45 L 45 5" /></svg></label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="searchVoto row card text-center" :id="item.Id_VotingUsers">
              <div class="card-header col-md-12">{{item.Nam_Person}} {{item.Last_NamePerson}}</div>
              <div class="card-body searchVotoSelect">
                <img width="200" height="200" :src="item.Det_Photo" :id="item.Id_VotingUsers" />                
                <b-modal size="lg" :id="'bv-modal-'+item.Id_VotingUsers" hide-footer>
                    <template v-slot:modal-title>Propuesta {{item.Nam_Person}} {{item.Last_NamePerson}}</template>
                    <div class="detallePro"><div v-html="item.Det_Proposal"></div></div>
                </b-modal>  
              </div>
              <div class="card-footer">
                <div class="row text-center">
                  <div class="col-md-6"><img src="@/assets/images/VotoPropuesta.png" class="img-fluid imgProp"  v-on:click="viewPropuesta('bv-modal-'+item.Id_VotingUsers)"/></div>
                  <div class="col-md-6">
                    <div class="form col-md-12">
                      <input type="checkbox" class="checkVal" :id="'check_'+item.Id_VotingUsers" v-on:click="executeVotoDocent" />
                      <label :for="'check_'+item.Id_VotingUsers" style="--d: 90%;"><svg viewBox="0,0,50,50"><path d="M5 30 L 20 45 L 45 5" /></svg></label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="votoEstudi" v-if="votoEstudi">
      <div class="titutleEst"><h3>Candidatos Estudiantes</h3></div>
      <div class="container">
        <div class="row">
          <div v-for="item of this.InfoRange.VotingStudents" :key="item.id" class="col-12 col-md-6 col-sm-12 col-lg-4">
            <div v-if="item.Id_Person === 0" class="searchVoto row card text-center" :id="item.Id_VotingUsers">
              <div class="card-header col-md-12">Voto en Blanco</div>
              <div class="card-body searchVotoSelect"><img width="200" height="200" src="@/assets/images/votoBlanco.png" class="img-fluid" id="item.Id_VotingUsers" /></div>
              <div class="card-footer">
                <div class="row text-center">
                  <div class="col-md-6"><img src="@/assets/images/VotoPropuesta.png" class="img-fluid imgProp imgPropVB" /></div>
                  <div class="col-md-6">
                    <div class="form col-md-12">
                      <input type="checkbox" class="checkVal" :id="'check_'+item.Id_VotingUsers" v-on:click="executeVotoAlumno" />
                      <label :for="'check_'+item.Id_VotingUsers" style="--d: 90%;"><svg viewBox="0,0,50,50"><path d="M5 30 L 20 45 L 45 5" /></svg></label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="searchVoto row card text-center" :id="item.Id_VotingUsers">
              <div class="card-header col-md-12">{{item.Nam_Person}} {{item.Last_NamePerson}}</div>
              <div class="card-body searchVotoSelect">
                <img width="200" height="200" :src="item.Det_Photo" :id="item.Id_VotingUsers" />                
                <b-modal size="lg" :id="'bv-modal-'+item.Id_VotingUsers" hide-footer>
                    <template v-slot:modal-title>Propuesta {{item.Nam_Person}} {{item.Last_NamePerson}}</template>
                    <div class="detallePro"><div v-html="item.Det_Proposal"></div></div>
                </b-modal>  
              </div>
              <div class="card-footer">
                <div class="row text-center">
                  <div class="col-md-6"><img src="@/assets/images/VotoPropuesta.png" class="img-fluid imgProp"  v-on:click="viewPropuesta('bv-modal-'+item.Id_VotingUsers)"/></div>
                  <div class="col-md-6">
                    <div class="form col-md-12">
                      <input type="checkbox" class="checkVal" :id="'check_'+item.Id_VotingUsers" v-on:click="executeVotoAlumno" />
                      <label :for="'check_'+item.Id_VotingUsers" style="--d: 90%;"><svg viewBox="0,0,50,50"><path d="M5 30 L 20 45 L 45 5" /></svg></label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
        <div class="text-left  col-md-10">
            <div v-if="NoVoto" class="alert alert-danger" role="alert">
                Por favor debe seleccionar un candidato para registrar su voto.
            </div>
        </div>
        <div class="text-right  col-md-2">
            <button type="submit" v-on:click="executeProcess" class="botonRef">Votar</button>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VotingForm",
  data() {
    return {
      voto:{
          student: "",
          teacher: "",
          refVoto: this.InfoRange.Id_VotingRange
      },
      votoDocen: false,
      votoEstudi: true,
      NoVoto:false
    };
  },
  methods: {
    executeProcess() {
        if((this.votoDocen) && this.voto.teacher === ''){
            this.NoVoto = true
        }        
        if(this.votoEstudi === true && this.voto.student === ''){
            this.NoVoto = true
        }        
        if(!this.NoVoto){
          this.method(this.voto);
        }
    },
    viewPropuesta(idref){
        this.$root.$emit('bv::show::modal', idref, '#btnShow');    
    },
    clearCheckboxes(idNot){
      var checkboxes = document.getElementsByTagName('input')
      for(var i=0;i<checkboxes.length;i++){
        if((checkboxes[i].type == "checkbox") && (idNot != checkboxes[i].id)){          
          checkboxes[i].checked=false;
        }
      }      
    },
    executeVotoDocent(event) {
      this.NoVoto = false
      if(event.target.checked){
        this.voto.teacher = event.target.id.substr(6);
      }else{
        this.voto.teacher = '';
      }
    },
    executeVotoAlumno(event) {            
      this.clearCheckboxes(event.target.id)
      this.NoVoto = false
      if(event.target.checked){
        this.voto.student = event.target.id.substr(6);
      }else{
        this.voto.student = '';
      }
    }
  },
  props: {
    method: Function,
    InfoRange: Object
  }
};
</script>

<style scoped>
.botonRef {
  margin-top: 5px;
  max-width: 200px;
  color: #222 !important;
  background-color: #fff !important;
  border-color: #222 !important;
  font-size: 15px;
  font-weight: bold;
  -webkit-box-shadow: 10px 10px 41px -20px rgba(249, 195, 68, 1);
  -moz-box-shadow: 10px 10px 41px -20px rgba(249, 195, 68, 1);
  box-shadow: 10px 10px 41px -20px rgba(249, 195, 68, 1);
}

.btn:hover, .btn:focus {
color: #ffffff !important;
  background-color: #222 !important;
  border-color: #222 !important;
  font-size: 15px;
  font-weight: bold;
  -webkit-box-shadow: 10px 10px 41px -20px rgba(249,195,68,1);
  -moz-box-shadow: 10px 10px 41px -20px rgba(249,195,68,1);
  box-shadow: 10px 10px 41px -20px rgba(249,195,68,1);
}

.btn:active
{
  border-color: #A3A6AA !important;
  background-color: #A3A6AA !important;
  color: #fff;
}
.selectVoto {
  background-color: #222 !important;
}

.VotingForm {
  
    background-color: #ffffff;
}


@media (min-width: 600px) {
  .VotingForm {
      margin: 50px;
      padding: 50px; 
  }
}

input.checkVal {
  position: absolute;
  opacity: 0;
}
input.checkVal:checked + label svg path {
  stroke-dashoffset: 0;
}
input.checkVal:focus + label {
  transform: scale(1.03);
}

.checkVal + label {
  display: block;
  border: 5px solid #979797;
  width: var(--d);
  height: var(--d);
  border-radius: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.checkVal + label:active {
  transform: scale(1.05);
  border-radius: 10px;
}
.checkVal + label svg {
  pointer-events: none;
}
.checkVal + label svg path {
  fill: none;
  stroke: #222;
  stroke-width: 4px;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-dasharray: 100;
  stroke-dashoffset: 101;
  transition: all 350ms cubic-bezier(1, 0, 0.37, 0.91);
  cursor: pointer;
}

.dtlvoto {
  font-size: 25px;
  font-weight: bold;
  padding: 10px;
}

.titutleDoc,
.titutleEst {
  display: none;
}

.votoEstudi, .votoDocen{
  padding: 30px;
}

.searchVoto {
  margin: 20px;
  box-shadow: 6px 6px 6px #cabec0;
  min-width: 240px !important;
}

.imgProp {
  width: 70%;
  cursor: pointer;
}

.card-header {
  text-transform: uppercase;
  min-height: 70px;
  max-height: 70px;  
}

.imgPropVB{
    opacity: 0.5;
    cursor:unset;
}

.detallePro{
  padding: 20px;
  text-align: justify;
}
</style>